import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  open: false
};

const loaderSlice = createSlice({
  name: 'loader',
  initialState,
  reducers: {
    show: (state) => {
      state.open = true;
    },
    hide: (state) => {
      state.open = false;
    }
  },
  extraReducers: (builder) => {
    builder.addCase('auth/logout', () => {
      return initialState;
    });
  }
});

export default loaderSlice.reducer;
export const loaderActions = loaderSlice.actions;
